// extracted by mini-css-extract-plugin
module.exports = {"loading_spinner":"style_loading_spinner__2J5UK","loading":"style_loading__2WkS7"};